<template>
    <div class="all">
        <div class="flex">
            <div style="font-weight: 600;font-size: 24px">欢迎登录咕鹿儿童书店系统后台</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm"
                style="width: 90%;margin-top: 20px">
                <el-form-item prop="username">
                    <el-input prefix-icon="el-icon-user" v-model="ruleForm.username" clearable></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input prefix-icon="el-icon-lock" show-password v-model="ruleForm.password" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="width: 100%;" type="primary" @click="submitForm('ruleForm')">登录</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { login } from '@/https/api';
export default {
    data() {
        return {
            ruleForm: {
                username: '',
                password: '',

            },
            rules: {
                username: [
                    { required: true, message: '请输入账户', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],

            },
        };
    },
    created() {
        let token = localStorage.getItem('token')
        if (token) {
            this.$router.push('/customer')
        }

    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login(this.ruleForm.username, this.ruleForm.password)
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //接口：获取标签信息 status: 0 删除 1上架 2下架
        async login(username, password) {
            let res = await login({
                username: username,
                password: password
            })
            console.log(res.data, '登录返回的信息')
            if (res.data.code == 200) {


                localStorage.setItem("token", res.data.data.token)
                localStorage.setItem("username", res.data.data.name)

                this.$message({
                    type: 'success',
                    message: '登录成功!'
                });

                this.$router.push('/customer')
            } else {
                this.$message({
                    type: 'warning',
                    message: res.data.msg
                });
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.all {
    width: 100%;
    height: 100%;
    background: url('../images/beijing.png');
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-position: center;
    /* 背景图片居中 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    display: flex;
    justify-content: end;
    align-items: center;
}

.flex {
    height: 50%;
    width: 20%;
    margin-right: 13%;
    margin-top: 16%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
}
</style>